<template>
  <v-container fluid>
    <!-- Поиск -->
    <v-row class="mb-3">
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>Таймлайны</v-card-title>
          <v-form ref="form">

            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4">
                  <date-time-picker v-model="date" :default="date"></date-time-picker>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4">
                  <user-selector 
                    v-model="agent" 
                    single 
                    with-sip 
                    @change:user="getUser"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" align="right">
                  <v-btn color="success" id="rep_btn" @click="loadReport" style="margin-top:13px;">Поиск</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-card>
      <v-card-title v-if="resultLoaded">
        <h4 class="mr-5">{{ chosenAgent }}</h4>
        <v-badge
          class="mr-8 my-2 mb-4"
          bordered
          color="success"
          overlap
         ><v-chip
              color="success"
              label
              outlined
          >Всего часов
          </v-chip>
          <template v-slot:badge>
            <span v-if="timeline.result.time_in_hours !== undefined">{{timeline.result.time_in_hours}}ч.</span>
          </template>
        </v-badge>
        <v-badge
          class="mr-8 my-2 mb-4"
          bordered
          color="success"
          overlap
         ><v-chip
              color="success"
              label
              outlined
          >Загрузка
          </v-chip>
          <template v-slot:badge>
            <span v-if="timeline.result.remainder_percent !== undefined">{{timeline.result.remainder_percent}}%</span>
          </template>
        </v-badge>
        <v-badge
          class="mr-8 my-2 mb-4"
          bordered
          color="success"
          overlap
         ><v-chip
              color="success"
              label
              outlined
          >Часов в разговорах
          </v-chip>
          <template v-slot:badge>
            <span v-if="timeline.result.sum_calls_in_hours !== undefined">{{timeline.result.sum_calls_in_hours}}ч.</span>
          </template>
        </v-badge>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              class="mr-8 my-2 mb-4"
              color="info"
              outlined
              label
              v-bind="attrs"
              v-on="on"
            >utilization
            </v-chip>
          </template>
          <span>Название формулы</span>
        </v-tooltip>
      </v-card-title>
      <timeline-charts v-if="loadChart" :data="chartPayload" />
    </v-card>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import TimelineCharts from '~/components/partials/TimelineCharts';
import UserSelector from '~/components/partials/selectors/UserSelector.vue';

export default {
  name: 'OperatorsTimeline',
  components: {TimelineCharts, UserSelector},

  data() {
    return {
      date: {},
      agent: [],
      user: {},
      chosenAgent: '',
      chartPayload: null,
      loadChart: false,
    };
  },

  computed: {
    ...mapGetters({
      timeline: 'timeline/timeline',
      resultLoaded: 'timeline/resultLoaded',
    }),
  },

  watch: {},

  methods: {
    ...mapActions({
      resetAllState: 'resetAllState',
      loadGraph: 'graphql/loadGraph',
    }),

    getUser(user) {
      this.user = user[0];
    },

    async loadReport() {
      if (!this.$refs.form.validate()) return

      this.loadChart = false; 
      this.chosenAgent = this.user.name;
      this.chartPayload = {
        period: [
          moment(this.date.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.date.end).format('YYYY-MM-DD HH:mm:ss'),
        ],
        agent: this.user.sip,
      }

      setTimeout(() => {
        this.loadChart = true; 
      }, 100)
    },
  },

  mounted() {
  },

  beforeDestroy() {
    this.resetAllState();
  },
};
</script>

<style>
</style>